import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { X } from "lucide-react";
import Select from "react-select";
import { components } from "react-select";
import { UpdateVfsuklpRole } from "../../../Redux/Action/VfsuklpAction";
import { UpdateAdminTeamPermission } from "../../../Redux/Action/MasterAdminAction";

export const EditAdminTeamRole = ({ setEditModalOpen, selectedRole ,permissionList,setSelectedPage,limit}) => {

    
    const dispatch = useDispatch();
    // get token from local storage
    const authToken = localStorage.getItem("Admin");
    const corporateID = JSON.parse(authToken)?.data?.corporateID;
    const [selectRole, setSelectRole] = useState('')
    const [branchList, setBranchList] = useState([]);
    const [selectBranch, setSelectBranch] = useState([]);
    const [selectBranchLabel, setSelectBranchLabel] = useState([]);
    const BranchList = useSelector((state) => state.Vfsuklp.ZoneWiseBranchList);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    const [selectAll, setSelectAll] = useState(false);
   
    const uk_roles = [
        { value: "adaccountant", label: "Accountant" },
        { value: "admanager", label: "Manager" },
        { value: "adsales", label: "Sales" },
        { value: "adsupport", label: "Support" },
      ];
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data={
            id: selectedRole._id,
            permission:selectedPermissions
        }
        dispatch(UpdateAdminTeamPermission(data, setEditModalOpen,setSelectedPage,limit))
    };


    const [roleData, setRoleData] = useState({
        name: "",
        email: "",
        contact: "",
        role: selectRole,
        countryCode: "",
        permission:selectedPermissions
    })
    useEffect(() => {
        if (selectedRole) {
            setRoleData({
                id: selectedRole._id,
                name: selectedRole.name,
                email: selectedRole.email,
                contact: selectedRole.contact,
                role: selectedRole.role,
                countryCode: selectedRole.countryCode,
                permission:selectedRole.permission
            });
            setSelectRole(selectedRole.role);
            setSelectedPermissions(selectedRole.permission)
            setSelectAll(selectedRole.permission.length === permissionList.length)
        }
    }, [selectedRole]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRoleData((prev) => ({
            ...prev,
            [name]: value,   // dynamically update based on input "name"
        }));
    };

    const handleRoleSelect = (selectedOptions) => {
        const values = selectedOptions.value
        // setRoleData(values);
        setRoleData((prev) => ({
            ...prev,
            role: values,
        }));
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            //   minWidth: '150px',
            //   maxWidth: window?.innerWidth > 600 && '210px',
            borderColor: state.isFocused ? "#fff100" : "#ececec",
            boxShadow: "none",
            "&:hover": { borderColor: "#ececec" },
            backgroundColor: state.isDisabled ? "#f2f2f2" : "white",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#262626",
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "2px 8px",
            minHeight: "38px", // instead of fixed height
            height: "auto", // allow it to expand
            flexWrap: "wrap", // let multiple values wrap
            overflow: "visible", // show all selected
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            color: "#262626",
            height: "38px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: "transparent",
            color: "black",
            display: "flex",
            alignItems: "center",
            "&:hover": {
                backgroundColor: "#f8f8f8",
            },
        }),
        menuList: (provided) => ({
            ...provided,
            //   maxHeight : '200px',
            //   overflowY : 'auto',
            padding: 0,
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: "#FCDD00",
            };
        },
    };
    const CheckboxOption = (props) => {
        return (
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null} // prevent default behavior
                    className="mr-2"
                />
                <label>{props.label}</label>
            </components.Option>
        );
    };

     
   const handleSelectAll = (e) => {
    const checked = e.target.checked;
    const updatedPermissions = checked ? permissionList : [];
    
    const setNew=updatedPermissions.map((item)=>item.id)
    
    setSelectedPermissions(setNew);
    setSelectAll(checked);
  };

  const handlePermissionSelect = (permission) => {
    
    const updatedPermissions = selectedPermissions.includes(permission.id)
      ? selectedPermissions.filter((p) => p !== permission.id)
      : [...selectedPermissions, permission.id];
    setSelectedPermissions(updatedPermissions);
    setRoleData((prev)=>({
      ...prev,
      permission:updatedPermissions
    }))
    setSelectAll(false);
    
  };
    return (
        <>
            <div
                className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${setEditModalOpen ? "translate-x-0" : "translate-x-full"
                    } flex flex-col`}
            >
                <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
                    <div className="flex items-center">
                        <h2 className="my-[7px] text-xl font-semibold text-gray-900">Edit Team Member</h2>
                    </div>
                    <button
                        onClick={() => setEditModalOpen(false)}
                        className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
                    >
                        <X className="w-5 h-5 text-gray-600" />
                    </button>
                </div>
                <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">

                    <form onSubmit={handleSubmit} id="formID">
                        <div className="flex flex-col gap-3 mb-5">
                            <div className="flex-col w-full gap-3 md:flex">
                                {/* name */}
                                <div className="flex flex-col gap-1">
                                    <span className="font-Poppins text-[15px] xl:text-base">
                                        Name<span className="text-[#fc0000]">*</span> :
                                    </span>
                                    <input
                                        className="py-[10px] xl:py-3 px-4 rounded-lg bg-gray-100 text-sm  outline-[#FCDD00] cursor-not-allowed"
                                        type="text"
                                        placeholder="Enter Name"
                                        id="name"
                                        name="name"
                                        value={roleData.name}
                                        onChange={handleChange}
                                        required
                                        autoComplete="off"
                                        maxLength={50}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="flex-col gap-3 md:flex">
                                <div className="flex flex-col gap-1">
                                    <span className="font-Poppins text-[15px] xl:text-base">
                                        Email Id<span className="text-[#fc0000]">*</span> :
                                    </span>
                                    <input
                                        className="py-[10px] xl:py-3 px-4 rounded-lg bg-gray-100 text-sm  outline-[#FCDD00] cursor-not-allowed"
                                        type="email"
                                        placeholder="Enter Branch Email Id"
                                        id="email"
                                        name="email"
                                        value={roleData.email}
                                        onChange={handleChange}
                                        required
                                        autoComplete="off"
                                        disabled
                                    />
                                </div>
                                <div className="flex flex-col gap-1">
                                    <span className="font-Poppins text-[15px] xl:text-base">
                                        Contact No<span className="text-[#fc0000]">*</span> :
                                    </span>
                  <div className="flex">
                                    <select className="py-[10px] xl:py-3 px-4 text-sm rounded-lg bg-gray-100 outline-[#FCDD00] w-1/4 cursor-not-allowed" 
                                    value={selectedRole?.countryCode || ""} 
                                    onChange={(e) => setRoleData({ ...roleData, countryCode: e.target.value })}
                                    disabled >
                                            <option  value={selectedRole?.countryCode} >
                                            {selectedRole?.countryCode}
                                            </option>
                  </select>
                                    <input
                                        className="py-[10px] xl:py-3 px-4 text-sm rounded-lg  bg-gray-100  outline-[#FCDD00] cursor-not-allowed w-full"
                                        type="tel"
                                        placeholder="Enter Branch Contact No"
                                        id="contact"
                                        name="contact"
                                        value={roleData.contact}
                                        onChange={handleChange}
                                        required
                                        autoComplete="off"
                                        // maxLength={10}
                                        minLength={0}
                                        disabled
                                    />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1">
                                <span className="font-Poppins text-[15px] xl:text-base">
                                    Role<span className="text-[#fc0000]">*</span> :
                                </span>
                                <Select
                                    options={uk_roles}
                                    placeholder="Select Role"
                                    // value={uk_roles?.filter((option) =>
                                    //   setSelectRole?.includes(option.value)
                                    // )}
                                    // onChange={handleRoleSelect}
                                    value={uk_roles.find((option) => option.label === selectRole)}
                                    onChange={handleRoleSelect}
                                    isSearchable={true}
                                    closeMenuOnSelect={false}
                                    // isMulti={true}
                                    isClearable={false}
                                    styles={customStyles}
                                    hideSelectedOptions={false}
                                    isDisabled={true}
                                    required
                                // components={{
                                //   Option: CheckboxOption,
                                //   IndicatorSeparator: () => null,
                                // }}
                                />
                            </div>
                        </div>
              {/* permissions */}
              <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                  <span className="font-Poppins text-[15px] xl:text-base">
                    Permissions<span className="text-[#fc0000]">*</span> :
                  </span>
                  <span className="font-Poppins text-[15px] xl:text-base">
                    <input type="checkbox" checked={selectAll} onChange={handleSelectAll}/> Select All
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2 md:col-span-1">
                     {permissionList.slice(0,7).map((permission) => (
                       <label key={permission.id} class="block py-1">
                         <input
                         type="checkbox"
                         className="mr-2"
                         checked={selectedPermissions.includes(permission.id)}
                         onChange={() => handlePermissionSelect(permission)}
                         />
                          {permission.pageName}
                       </label>
                     ))}
                    </div>
                    <div className="col-span-2 md:col-span-1">
                      {permissionList.slice(7).map((permission) => (
                        <label key={permission.id} class="block py-1">
                          <input
                          type="checkbox"
                          className="mr-2"
                          checked={selectedPermissions.includes(permission.id)}
                          onChange={() => handlePermissionSelect(permission)}
                          />
                           {permission.pageName}
                        </label>
                      ))}
                    </div>
                </div>
              </div>           
                    </form>
                </div>
                {/* Footer Actions */}
                <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
                    <button
                        type="submit"
                        form="formID"
                        className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
                    >
                        Update
                    </button>

                    <button
                        onClick={() => setEditModalOpen(false)}
                        className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    >
                        {/* <X className="w-4 h-4 mr-2" /> */}
                        Close
                    </button>
                </div>
            </div>
        </>
    );
};